import React from "react";
import { z } from "zod";

import { Alert } from "~/components/alert";
import { useScoped } from "~/tools/impulse";
import { DASHBOARD_SAVE_ALERT_DISMISSED, LocalStorage } from "~/tools/local-storage";

import { DocLink } from "../../../components/react/docLink/DocLink";

export interface DashboardSaveAlertProps {
	className?: string;

	/**
	 * The contextual place where the alert is shown. It is used to make a local storage key to track the dismissal state.
	 */
	placement: string;
}

export const DashboardSaveAlert: React.FC<DashboardSaveAlertProps> = ({ className, placement }) => {
	const key = `${DASHBOARD_SAVE_ALERT_DISMISSED}/${placement}`;
	const dismissed = useScoped((scope) => LocalStorage.getItem(scope, key, z.boolean()), [key]);

	if (dismissed) {
		return null;
	}

	return (
		<Alert className={className} onClose={() => LocalStorage.setItem(key, true)}>
			You are about to make changes to the current dashboard. However, you still have to{" "}
			<strong className="font-bold">save the dashboard</strong> if you want these changes to be persistent. To learn
			more about dashboards, check{" "}
			<DocLink capture="noop" slug="ui-dashboards">
				our docs
			</DocLink>
			.
		</Alert>
	);
};
